import { Pipe, PipeTransform } from "@angular/core";
import { hasNoAppAccess } from "../../../../common/app-access";
import { User } from "../../services/user/user.service";

@Pipe({ name: "hasNoAppAccess" })
export class HasNoAppAccessPipe implements PipeTransform {
  transform(user: User): boolean {
    return hasNoAppAccess(user);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/app-access/has-no-app-access.pipe.ts